"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import {
	checkGlobalPrivacyControl,
	checkIfCCPAUser,
	useConsentStore,
} from "@/lib/analytics/consent";

export function CCPAFooter() {
	const [showCCPALink, setShowCCPALink] = useState(false);
	const { setIsCCPAUser, updatePreferences } = useConsentStore();

	useEffect(() => {
		const checkCCPA = async () => {
			const isCalifornia = await checkIfCCPAUser();
			setIsCCPAUser(isCalifornia);
			setShowCCPALink(isCalifornia);

			// Also check for Global Privacy Control
			if (checkGlobalPrivacyControl()) {
				// Automatically opt out if GPC is enabled
				updatePreferences(false);
			}
		};

		checkCCPA();
	}, [setIsCCPAUser, updatePreferences]);

	const handleDoNotSell = (e: React.MouseEvent) => {
		e.preventDefault();
		updatePreferences(false);
		alert(
			"Your opt-out preference has been saved. We will not sell or share your personal information.",
		);
	};

	if (!showCCPALink) return null;

	return (
		<div className="text-center text-muted-foreground text-xs">
			<a href="#" onClick={handleDoNotSell} className="hover:text-primary">
				Do Not Sell or Share My Personal Information
			</a>
			{" • "}
			<Link href="/settings/privacy" className="hover:text-primary">
				Your Privacy Rights
			</Link>
		</div>
	);
}
